import api from "../../components/api"
import { InvoiceSendOptions } from "./invoicingApi"
import { InvoicePaymentStatus } from "./payment"
import { StatementDetail } from "./statement"

export const getStatement = async (statementId: string): Promise<StatementDetail> => {
  return (await api.get(`/web/invoicing/statement/${statementId}`)).data
}

export const getStatementPaymentStatus = async (statementId: string): Promise<InvoicePaymentStatus> => {
  return (await api.get(`/web/invoicing/statement/${statementId}/payment-status`)).data
}

export type MarkStatementPaidManuallyRequest = {
  statementId: string
  paymentMethod: 'cash' | 'check'
  checkNumber?: string
}

export const markStatementPaidManually = async (data: MarkStatementPaidManuallyRequest): Promise<void> => {
  return await api.post(`/web/invoicing/statement/${data.statementId}/manually-mark-paid`, {
    paymentMethod: data.paymentMethod,
    checkNumber: data.checkNumber
  })
}

export type SendStatementRequest = {
  statementId: string
  emailAddresses: string[]
  invoiceUpdates?: InvoiceSendOptions | null
}

export const sendStatement = async (data: SendStatementRequest): Promise<void> => {
  return await api.post(`/web/invoicing/statement/${data.statementId}/send-email`, data)
}

export const markStatementNotPaidManually = async (statementId: string): Promise<void> => {
  return await api.post(`/web/invoicing/statement/${statementId}/manually-mark-not-paid`)
}

export const deleteStatement = async (statementId: string, deleteFromQuickBooks: boolean): Promise<void> => {
  return await api.delete(`/web/invoicing/statement/${statementId}?deleteQboInvoices=${deleteFromQuickBooks}`)
}
